import { faDraftingCompass } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
// import { KBLinks } from 'constant';

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  background-color: transparent;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0;

  > div {
    width: auto;
    max-width: inherit;
  }
`;

export const TemplateEmptyState: FC = () => (
  <EmptyStateContainer>
    <EmptyState
      direction="horizontal"
      size="large"
      image={<EmptyStateIcon icon={faDraftingCompass} size="10x" />}
      title={<FormattedMessage id="template.phase.empty.title" />}
      message={<FormattedMessage id="template.phase.empty.message" />}
      // secondaryCTA={
      //   <EmptyState.CallToAction.Secondary
      //     href={KBLinks.projectPlanTemplate}
      //     target="_blank"
      //   >
      //     <FormattedMessage id="template.phase.empty.secondary" />
      //   </EmptyState.CallToAction.Secondary>
      // }
    />
  </EmptyStateContainer>
);
